export const isLocker = (s: string) => /locker/i.test(s)
